module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l((_vm.icons), function(icon) {
    return _c('span', {
      staticClass: "border m-2 p-2",
      staticStyle: {
        "width": "200px",
        "height": "100px"
      }
    }, [_c('span', {
      staticClass: "d-flex justify-content-center"
    }, [_c('icon', {
      attrs: {
        "name": icon,
        "scale": "2"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "d-flex justify-content-center"
    }, [_vm._v(_vm._s(icon))])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07e5a39a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/IconsPage.vue
// module id = 2136
// module chunks = 1